import { FlexConditionOperator } from '@/data/data-models';

export const conditionOperatorNames = {
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    EXISTS: 'exists',
    NOT_EXISTS: 'notExists',
    INCLUDES: 'includes',
    NOT_INCLUDES: 'notIncludes',
    GREATER_THAN: 'greaterThan',
    LESS_THAN: 'lessThen',
    IS_VALID: 'isValid', // this is for forms and form fields
    IS_EMPTY: 'isEmpty', // this is for collections
    IS_NOT_EMPTY: 'isNotEmpty', // this is for collections
};

export default new Map([
    [conditionOperatorNames.EQUALS, new FlexConditionOperator({
        name: conditionOperatorNames.EQUALS,
        label: 'equals',
        computation: (a, b) => a == b, /* eslint-disable-line eqeqeq */
        component: 'condition-operator-equals',
    })],

    [conditionOperatorNames.EXISTS, new FlexConditionOperator({
        name: conditionOperatorNames.EXISTS,
        label: 'exists',
        // n.b. browsers return null when a cookie does not exist, as well as when the cookie exists - but has no value
        computation: a => typeof a !== 'undefined' && a !== null,
    })],

    [conditionOperatorNames.INCLUDES, new FlexConditionOperator({
        name: conditionOperatorNames.INCLUDES,
        label: 'includes',
        computation: (a, b) => {
            if (typeof a !== 'string' && !Array.isArray(a)) return false;

            return a.includes(b);
        },
        component: 'condition-operator-includes',
    })],

    [conditionOperatorNames.NOT_EQUALS, new FlexConditionOperator({
        name: conditionOperatorNames.NOT_EQUALS,
        label: 'does not equal',
        computation: (a, b) => a != b, /* eslint-disable-line eqeqeq */
        component: 'condition-operator-equals',
    })],

    [conditionOperatorNames.NOT_EXISTS, new FlexConditionOperator({
        name: conditionOperatorNames.NOT_EXISTS,
        label: 'does not exist',
        computation: a => typeof a === 'undefined' || a === null,
    })],

    [conditionOperatorNames.NOT_INCLUDES, new FlexConditionOperator({
        name: conditionOperatorNames.NOT_INCLUDES,
        label: 'does not include',
        computation: (a, b) => {
            if (typeof a !== 'string' && !Array.isArray(a)) return true;

            return !a.includes(b);
        },
        component: 'condition-operator-includes',
    })],

    [conditionOperatorNames.GREATER_THAN, new FlexConditionOperator({
        name: conditionOperatorNames.GREATER_THAN,
        label: 'is greater than',
        computation: (a, b) => {
            a = typeof a === 'number' ? a : Number(a);
            b = typeof b === 'number' ? b : Number(b);

            return a > b;
        },
        component: 'condition-operator-greater-less',
    })],

    [conditionOperatorNames.LESS_THAN, new FlexConditionOperator({
        name: conditionOperatorNames.LESS_THAN,
        label: 'is less than',
        computation: (a, b) => {
            a = typeof a === 'number' ? a : Number(a);
            b = typeof b === 'number' ? b : Number(b);

            return a < b;
        },
        component: 'condition-operator-greater-less',
    })],

    [conditionOperatorNames.IS_VALID, new FlexConditionOperator({
        name: conditionOperatorNames.IS_VALID,
        label: 'is valid',
        computation: (f) => {
            const isValidInput = !!f
                && typeof f === 'object'
                && typeof f.checkValidity === 'function';

            return isValidInput && f.checkValidity();
        },
    })],

    [conditionOperatorNames.IS_EMPTY, new FlexConditionOperator({
        name: conditionOperatorNames.IS_EMPTY,
        label: 'is empty',
        computation: (c) => {
            return Array.isArray(c) ? !c.length : !c;
        },
    })],

    [conditionOperatorNames.IS_NOT_EMPTY, new FlexConditionOperator({
        name: conditionOperatorNames.IS_NOT_EMPTY,
        label: 'is not empty',
        computation: (c) => {
            return Array.isArray(c) ? !!c.length : !!c;
        },
    })],
]);
